import { Task } from '@griply/types';
import {
  getCompletedTasksInRangeFilterOptions,
  isNotArchived,
} from '@griply/utils';
import { endOfDay, startOfDay } from 'date-fns';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useFilteredTasksQuery } from 'shared/hooks/queries/use-filtered-tasks-query';
import { useUser } from 'shared/hooks/use-user';

// Its own bounded subscription, not the shared unbounded completed one: the server `completedAt` range is what
// enforces the window. Plain tasks only (`tasksOnly` in the shared options) — habits and repeating tasks done for
// today come from `useTodaysCompletedHabits`, so a habit that also carries `completedAt` is not listed twice.
export const useTodaysCompletedTasks = (): Task[] => {
  const today = useToday();
  const user = useUser();

  const filterOptions = useMemo(
    () =>
      getCompletedTasksInRangeFilterOptions(startOfDay(today), endOfDay(today)),
    [today],
  );

  const { data: tasks } = useFilteredTasksQuery(user?.uid, filterOptions);

  // Timeslot (`action`) tasks stay in — the uncompleted list shows them too.
  return useMemo(
    () =>
      tasks.filter((task) => !task.parentIds?.length && isNotArchived(task)),
    [tasks],
  );
};
